import { ListboxButton } from "@headlessui/react";
import { Down } from "@icon-park/svg";
import clsx from "clsx";
import { forwardRef } from "react";
import Icon from "../Icon";
import { SelectButtonProps } from "./types";

const SelectButton = forwardRef<any, SelectButtonProps>(function SelectButton(
  { disabled, size, className, children },
  ref,
) {
  return (
    <ListboxButton
      ref={ref}
      tabIndex={disabled ? -1 : 0}
      className={clsx(
        "w-full border transition-colors ease-out flex items-center justify-between bg-neutral-0 border-neutral-50 text-neutral-575",
        {
          "cursor-pointer hover:border-neutral-100 focus-within:border-neutral-100 focus:outline-none":
            !disabled,
          "bg-neutral-12 border-neutral-25 cursor-not-allowed": disabled,
          "text-app-body-2 py-[7px] px-3xs rounded-xs": size === "sm",
          "text-body-2 py-[11px] px-s rounded-s": size === "md",
        },
        className,
      )}
    >
      {({ open }) => (
        <>
          {children}
          <span
            className={clsx("ml-xs  flex relative", {
              "text-primary-800": !disabled,
              "text-neutral-150": disabled,
            })}
            aria-hidden="true"
          >
            <Icon
              icon={Down}
              size={size === "sm" ? 20 : 24}
              className={clsx({ "rotate-180": open })}
            />
            <div className="absolute inset-none"></div>
          </span>
        </>
      )}
    </ListboxButton>
  );
});

export default SelectButton;
